import {useNavigate} from "react-router-dom";
const useHezb=()=>{
    const navigate=useNavigate();
    const hezb=[
        {id:1,ayyah:1,secondId:2,secondAyyah:43},
        {id:2,ayyah:44,secondId:2,secondAyyah:74},
        {id:2,ayyah:75,secondId:2,secondAyyah:105},
        {id:2,ayyah:106,secondId:2,secondAyyah:141},
        {id:2,ayyah:142,secondId:2,secondAyyah:176},
        {id:2,ayyah:177,secondId:2,secondAyyah:202},
        {id:2,ayyah:203,secondId:2,secondAyyah:232},
        {id:2,ayyah:233,secondId:2,secondAyyah:252},
        {id:2,ayyah:253,secondId:2,secondAyyah:271},
        {id:2,ayyah:272,secondId:3,secondAyyah:14},
        {id:3,ayyah:15,secondId:3,secondAyyah:51},
        {id:3,ayyah:52,secondId:3,secondAyyah:92},
        {id:3,ayyah:93,secondId:3,secondAyyah:132},
        {id:3,ayyah:133,secondId:3,secondAyyah:170},
        {id:3,ayyah:171,secondId:3,secondAyyah:200},
        {id:4,ayyah:1,secondId:4,secondAyyah:23},
        {id:4,ayyah:24,secondId:4,secondAyyah:57},
        {id:4,ayyah:58,secondId:4,secondAyyah:87},
        {id:4,ayyah:88,secondId:4,secondAyyah:113},
        {id:4,ayyah:114,secondId:4,secondAyyah:147},
        {id:4,ayyah:148,secondId:4,secondAyyah:176},
        {id:5,ayyah:1,secondId:5,secondAyyah:26},
        {id:5,ayyah:27,secondId:5,secondAyyah:50},
        {id:5,ayyah:51,secondId:5,secondAyyah:81},
        {id:5,ayyah:82,secondId:5,secondAyyah:108},
        {id:5,ayyah:109,secondId:6,secondAyyah:35},
        {id:6,ayyah:36,secondId:6,secondAyyah:73},
        {id:6,ayyah:74,secondId:6,secondAyyah:110},
        {id:6,ayyah:111,secondId:6,secondAyyah:140},
        {id:6,ayyah:141,secondId:6,secondAyyah:165},
        {id:7,ayyah:1,secondId:7,secondAyyah:46},
        {id:7,ayyah:47,secondId:7,secondAyyah:87},
        {id:7,ayyah:88,secondId:7,secondAyyah:141},
        {id:7,ayyah:142,secondId:7,secondAyyah:170},
        {id:7,ayyah:171,secondId:7,secondAyyah:206},
        {id:8,ayyah:1,secondId:8,secondAyyah:40},
        {id:8,ayyah:41,secondId:9,secondAyyah:75},
        {id:9,ayyah:1,secondId:9,secondAyyah:33},
        {id:9,ayyah:34,secondId:9,secondAyyah:59},
        {id:9,ayyah:60,secondId:9,secondAyyah:92},
        {id:9,ayyah:93,secondId:9,secondAyyah:121},
        {id:9,ayyah:122,secondId:10,secondAyyah:25},
        {id:10,ayyah:26,secondId:10,secondAyyah:70},
        {id:10,ayyah:71,secondId:11,secondAyyah:5},
        {id:11,ayyah:6,secondId:11,secondAyyah:40},
        {id:11,ayyah:41,secondId:11,secondAyyah:83},
        {id:11,ayyah:84,secondId:12,secondAyyah:6},
        {id:12,ayyah:7,secondId:12,secondAyyah:52},
        {id:12,ayyah:53,secondId:12,secondAyyah:100},
        {id:12,ayyah:101,secondId:13,secondAyyah:18},
        {id:13,ayyah:19,secondId:14,secondAyyah:9},
        {id:14,ayyah:10,secondId:14,secondAyyah:52},
        {id:15,ayyah:1,secondId:15,secondAyyah:99},
        {id:16,ayyah:1,secondId:16,secondAyyah:50},
        {id:16,ayyah:51,secondId:16,secondAyyah:89},
        {id:16,ayyah:90,secondId:16,secondAyyah:128},
        {id:17,ayyah:1,secondId:17,secondAyyah:49},
        {id:17,ayyah:50,secondId:17,secondAyyah:98},
        {id:17,ayyah:99,secondId:18,secondAyyah:31},
        {id:18,ayyah:32,secondId:18,secondAyyah:74},
        {id:18,ayyah:75,secondId:19,secondAyyah:21},
        {id:19,ayyah:22,secondId:19,secondAyyah:98},
        {id:20,ayyah:1,secondId:20,secondAyyah:82},
        {id:20,ayyah:83,secondId:20,secondAyyah:135},
        {id:21,ayyah:1,secondId:21,secondAyyah:50},
        {id:21,ayyah:51,secondId:21,secondAyyah:112},
        {id:22,ayyah:1,secondId:22,secondAyyah:37},
        {id:22,ayyah:38,secondId:22,secondAyyah:78},
        {id:23,ayyah:1,secondId:23,secondAyyah:74},
        {id:23,ayyah:74,secondId:24,secondAyyah:20},
        {id:24,ayyah:21,secondId:24,secondAyyah:52},
        {id:24,ayyah:53,secondId:25,secondAyyah:20},
        {id:25,ayyah:21,secondId:25,secondAyyah:77},
        {id:26,ayyah:1,secondId:26,secondAyyah:110},
        {id:26,ayyah:111,secondId:26,secondAyyah:227},
        {id:27,ayyah:1,secondId:27,secondAyyah:55},
        {id:27,ayyah:56,secondId:28,secondAyyah:11},
        {id:28,ayyah:12,secondId:28,secondAyyah:50},
        {id:28,ayyah:51,secondId:28,secondAyyah:88},
        {id:29,ayyah:1,secondId:29,secondAyyah:45},
        {id:29,ayyah:46,secondId:30,secondAyyah:30},
        {id:30,ayyah:31,secondId:31,secondAyyah:21},
        {id:31,ayyah:22,secondId:32,secondAyyah:30},
        {id:33,ayyah:1,secondId:33,secondAyyah:30},
        {id:33,ayyah:31,secondId:33,secondAyyah:59},
        {id:33,ayyah:60,secondId:34,secondAyyah:23},
        {id:34,ayyah:24,secondId:35,secondAyyah:14},
        {id:35,ayyah:15,secondId:36,secondAyyah:27},
        {id:36,ayyah:28,secondId:37,secondAyyah:21},
        {id:37,ayyah:22,secondId:37,secondAyyah:144},
        {id:37,ayyah:145,secondId:38,secondAyyah:51},
        {id:38,ayyah:52,secondId:39,secondAyyah:31},
        {id:39,ayyah:32,secondId:39,secondAyyah:75},
        {id:40,ayyah:1,secondId:40,secondAyyah:40},
        {id:40,ayyah:41,secondId:41,secondAyyah:8},
        {id:41,ayyah:9,secondId:41,secondAyyah:46},
        {id:41,ayyah:47,secondId:42,secondAyyah:26},
        {id:42,ayyah:27,secondId:43,secondAyyah:23},
        {id:43,ayyah:24,secondId:44,secondAyyah:16},
        {id:44,ayyah:17,secondId:45,secondAyyah:37},
        {id:46,ayyah:1,secondId:47,secondAyyah:9},
        {id:47,ayyah:10,secondId:48,secondAyyah:17},
        {id:48,ayyah:18,secondId:49,secondAyyah:13},
        {id:49,ayyah:14,secondId:51,secondAyyah:30},
        {id:51,ayyah:31,secondId:53,secondAyyah:25},
        {id:51,ayyah:31,secondId:53,secondAyyah:25},
        {id:51,ayyah:26,secondId:54,secondAyyah:55},
        {id:55,ayyah:1,secondId:56,secondAyyah:74},
        {id:56,ayyah:75,secondId:57,secondAyyah:29},
        {id:58,ayyah:1,secondId:59,secondAyyah:10},
        {id:59,ayyah:11,secondId:61,secondAyyah:14},
        {id:62,ayyah:1,secondId:64,secondAyyah:18},
        {id:65,ayyah:1,secondId:66,secondAyyah:12},
        {id:67,ayyah:1,secondId:68,secondAyyah:52},
        {id:69,ayyah:1,secondId:71,secondAyyah:28},
        {id:72,ayyah:1,secondId:74,secondAyyah:56},
        {id:75,ayyah:1,secondId:77,secondAyyah:50},
        {id:78,ayyah:1,secondId:81,secondAyyah:29},
        {id:82,ayyah:1,secondId:86,secondAyyah:17},
        {id:87,ayyah:1,secondId:93,secondAyyah:11},
        {id:94,ayyah:1,secondId:114,secondAyyah:6},
    ]
    return (number)=>{
        let item=hezb[number-1];
        navigate(`/view?id=${item.id}&ayyah=${item.ayyah}&secondId=${item.secondId}&secondAyyah=${item.secondAyyah}`);
    }
}
export default useHezb;